import React from "react";
import { Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CustomApprovalModal from "@/shared/components/custom-modal";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// API 연동 요청 접수 완료 안내 모달 — 등록 신청 내역으로 이동 가능
function PathPickBasketSyncCompleteModal({ isOpen, onClose }: Props) {
  const { t } = useI18nHelper();
  const navigate = useNavigate();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      // 화면보다 넓으면 왼쪽이 스크롤로도 닿지 않아 화면 폭으로 클램프한다.
      minWidth={"min(640px, 92dvw)"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick:basket.sync_complete.title")}
      />
      <CustomApprovalModal.Body>
        <Text textStyle={"body-md-regular"} color={"#1D1D1B"}>
          {t("path_pick:basket.sync_complete.body")}
        </Text>
      </CustomApprovalModal.Body>
      <CustomApprovalModal.Footer
        cancelName={t("path_pick:basket.sync_complete.close")}
        confirmName={t("path_pick:basket.sync_complete.go_to_history")}
        onCancel={onClose}
        onConfirm={() => navigate("/pathpick/sync-download-history")}
        confirmBtnProps={{ width: "200px" }}
      />
    </CustomApprovalModal>
  );
}

export default PathPickBasketSyncCompleteModal;
